import type { SentryModule } from '../types';

export const CONTAINER_MODULE_MAP: Readonly<
  Partial<Record<string, SentryModule>>
> = {
  SUMMARY: 'summary',
  ANALYTICS_V2: 'summary',
  TRANSACTIONS: 'payments',
  PAYMENT_LINKS: 'payment_links',
  PAYMENT_FORMS: 'payment_forms',
  PAYMENT_BUTTONS: 'payment_buttons',
  SETTLEMENTS: 'settlements',
  SETTLEMENT_DETAILS: 'settlements',
  SETTLEMENT_RECON_DETAILS: 'settlements',
  REPORTS: 'reports',
  SETTINGS: 'settings',
  BRANDING: 'customisation',
  DEVELOPERS: 'developers',
  API_KEYS: 'developers',
  WEBHOOKS: 'developers',
  EASY_SPLIT: 'easy_split',
  EASY_SPLIT_DETAILS: 'easy_split',
  CUSTOMERS: 'customers',
  SUBSCRIPTIONS: 'subscriptions',
  SUBSCRIPTION_DETAILS: 'subscriptions',
  OFFERS: 'offers',
  OFFERS_DESCRIPTION: 'offers',
  OFFERS_V2_CREATE: 'offers',
  OFFERS_DESCRIPTION_V2: 'offers',
  CHECKOUT_ONE: 'one_click_checkout',
  RISKSHIELD: 'risk_shield',
  DISPUTE_DETAILS: 'disputes',
  REFUNDS_DETAIL: 'refunds',
  ORDERS_DESCRIPTION: 'orders',
  SOFTPOS: 'softpos',
  APPS: 'payment_buttons',
  WORKFLOWS: 'developers',
  BATCH_REFUNDS: 'refunds',
};
